// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookitupNotification } from '../../../../Types/LogT';

const ContractWithdrawn: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { eventId, entityId } = notification;
  const navigate = useNavigate();
  const contractId = entityId;
  const canOpenContract = Boolean(eventId && contractId);

  return (
    <Text>
      <Text
        span
        weight="bolder"
        variant={canOpenContract ? 'link' : undefined}
        color={canOpenContract ? 'blue' : undefined}
        onClick={() => canOpenContract && navigate(`/events/${eventId}/contracts/${contractId}/preview`)}
        sx={{ cursor: canOpenContract ? 'pointer' : 'default' }}
      >
        Contract
      </Text>
      {'  '}wurde zurückgezogen.
    </Text>
  );
};

export default ContractWithdrawn;
